import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  cookiesSnackbar: {
    maxWidth: 436,
    padding: 16,
    backgroundColor: '#262626',
    color: '#FFFFFF',
    borderRadius: 8,
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.3)'
  },
  privacyLink: {
    color: '#8D8D8D'
  },
  cookiesSnackbarOkContainer: {
    textAlign: 'right'
  },
  cookiesSnackbarOkButton: {
    marginBottom: 0
  }
}))

export default useStyles
